/**
 *
 * @Pattern https://mgechev.github.io/angularjs-in-patterns/#facade
 */

export default function Locations(LocationService) {
    var fn = this;

    /**
     * API v3
     */
    fn.get = () => {
        return LocationService.get();
    };

    fn.getAll = () => {
        return LocationService.getAll();
    };

    return fn;
}
